// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** Mixins **/
/** Vars (common) **/
/** app colors **/
/** Vars (MuiAlert) **/
/** main classes **/
.nibTable_old-container__RV\\+6c {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  position: relative;
  width: 100%;
}
.nibTable_old-container__RV\\+6c.nibTable_wrap__Ie63P {
  flex-wrap: wrap;
}
.nibTable_old-container__RV\\+6c .nibTable_box__C9CFj.nibTable_col__kjBfg {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 0 10px;
}
.nibTable_old-container__RV\\+6c .nibTable_box__C9CFj.nibTable_col__kjBfg > div {
  width: 100%;
}
.nibTable_old-container__RV\\+6c .nibTable_box__C9CFj.nibTable_row__YkmbY {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
}
.nibTable_old-container__RV\\+6c form {
  padding: 20px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  position: relative;
  flex-wrap: wrap;
  width: 100%;
}
.nibTable_old-container__RV\\+6c form > .nibTable_box__C9CFj.nibTable_col__kjBfg {
  flex-basis: 33.33%;
}
@media screen and (min-width: 2560px) {
  .nibTable_old-container__RV\\+6c form > .nibTable_box__C9CFj.nibTable_col__kjBfg {
    flex-basis: 0%;
    margin-right: 2em;
  }
}

@media screen and (max-width: 580px) {
  .nibTable_old-container__RV\\+6c, .nibTable_col__kjBfg, form {
    padding: 5px;
  }
}
@media screen and (max-width: 450px) {
  .nibTable_old-container__RV\\+6c, .nibTable_col__kjBfg, form {
    padding: 0px;
  }
}
.nibTable_text-overflow-hidden__jsD6Y {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.nibTable_icon__U4zja {
  color: var(--accent-color);
}

.nibTable_richtext-output-wrap__hlze6 .nibTable_se-video-container__3p-Tp figure {
  padding-bottom: 0 !important;
}

.nibTable_wrap__Ie63P {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
}
.nibTable_wrap__Ie63P .nibTable_toolbar__hMvPx {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
}
.nibTable_wrap__Ie63P .nibTable_toolbar__hMvPx .nibTable_filtersWrapper__gVo3C {
  display: flex;
  flex-wrap: wrap;
}
.nibTable_wrap__Ie63P .nibTable_toolbar__hMvPx .nibTable_filtersWrapper__gVo3C + * {
  margin-left: 20px;
}
.nibTable_wrap__Ie63P .nibTable_toolbar__hMvPx .nibTable_field__NrESo {
  margin-bottom: 10px;
  margin-right: 10px;
}
.nibTable_wrap__Ie63P .nibTable_toolbar__hMvPx .nibTable_field__NrESo:last-child {
  margin-right: 0;
}
.nibTable_wrap__Ie63P > div {
  width: 100%;
}
.nibTable_wrap__Ie63P .nibTable_end__bTSEK {
  padding: 10px;
  text-align: center;
  width: 100%;
  padding-bottom: 20px;
  font-size: 120%;
  color: #cecece;
}
.nibTable_wrap__Ie63P .nibTable_loader__gBstn {
  width: 100%;
  padding: 20px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.nibTable_table__isvFK {
  width: 100%;
  border-radius: 15px;
  overflow: hidden;
  background-color: #3D3D3D;
  border-collapse: collapse;
  border-width: 0;
}
.nibTable_table__isvFK td {
  border: 0 solid transparent;
  background-clip: padding-box;
}
.nibTable_table__isvFK tr > td + td {
  border-left-width: 2px;
}
.nibTable_table__isvFK tr + tr > td {
  border-top-width: 2px;
}
.nibTable_table__isvFK thead th {
  min-height: 55px;
  max-height: 55px;
  height: 55px;
  background-color: #3D3D3D;
  text-align: right;
  padding-right: 20px;
  /* word-break: break-word */
  white-space: nowrap;
  color: #fff;
  position: sticky;
  top: 0;
  z-index: 99;
}
.nibTable_table__isvFK thead th span {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.nibTable_table__isvFK thead th.nibTable_add__NtkP9 {
  padding: 10px;
}
.nibTable_table__isvFK thead th.nibTable_add__NtkP9 > div {
  width: 100%;
}
.nibTable_table__isvFK thead th.nibTable_add__NtkP9 > div button {
  width: 100%;
}
.nibTable_table__isvFK tbody {
  border-radius: 15px;
}
.nibTable_table__isvFK tbody tr {
  min-height: 55px;
  max-height: 55px;
  height: 55px;
}
.nibTable_table__isvFK tbody tr:nth-child(odd) td {
  background-color: #2A2A2A;
}
.nibTable_table__isvFK tbody tr td {
  background-color: #2F2F2F;
  text-align: right;
  padding: 0;
  color: #fff;
}
.nibTable_table__isvFK tbody tr td > div, .nibTable_table__isvFK tbody tr td > p, .nibTable_table__isvFK tbody tr td > span {
  min-height: 55px;
  max-height: 55px;
  height: 55px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  height: 100%;
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 5px;
  padding-right: 20px;
}
.nibTable_table__isvFK tbody tr td > div > div, .nibTable_table__isvFK tbody tr td > p > div, .nibTable_table__isvFK tbody tr td > span > div {
  width: 100%;
}
.nibTable_table__isvFK tbody tr td > div, .nibTable_table__isvFK tbody tr td > p {
  transition: background-color 0.5s ease;
}
.nibTable_table__isvFK tbody tr td > div.nibTable_error__2WTkJ, .nibTable_table__isvFK tbody tr td > p.nibTable_error__2WTkJ {
  background-color: #f44336;
}

.nibTable_edit__c2n8X {
  width: 55px;
  padding: 0;
}
.nibTable_edit__c2n8X > div {
  width: 100%;
  padding: 0 !important;
}
.nibTable_edit__c2n8X > div button {
  width: 100%;
}

.nibTable_inputCell__-BQyu, .nibTable_dateCell__V-zEZ, .nibTable_selectCell__Lu-Gd, .nibTable_customCell__h\\+AXC {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
}

.nibTable_inputCell__-BQyu {
  margin-right: 80px;
}

.nibTable_selectCell__Lu-Gd {
  margin-right: 80px;
}

.nibTable_link__in50l {
  text-decoration: underline;
}
.nibTable_link__in50l .nibTable_linkIcon__UAJkd svg {
  color: var(--accent-color) !important;
  vertical-align: super;
  padding: 0 2px;
}

.nibTable_customCell__h\\+AXC {
  padding: 0;
}

.nibTable_eyeCell__T-8aN svg {
  color: var(--accent-color);
}
.nibTable_eyeCell__T-8aN:disabled svg {
  color: unset;
}

.nibTable_selectCell__Lu-Gd.nibTable_MuiInput-underline__7xoQ9::after {
  border-bottom-color: var(--accent-color) !important;
}
.nibTable_selectCell__Lu-Gd svg {
  color: #fff;
}
.nibTable_selectCell__Lu-Gd::before {
  border-bottom: 2px solid var(--accent-color);
}
.nibTable_selectCell__Lu-Gd:hover::before {
  border-bottom-color: #fff !important;
}

.nibTable_pagination__vi1P4 {
  margin-top: 5px;
  width: calc(100% - 4px);
  height: 40px;
  max-height: 40px;
  margin-bottom: 5px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.nibTable_pagination__vi1P4 .nibTable_railWayWrap__euYKw {
  background-color: #2F2F2F;
  border: 1px solid rgba(var(--accent-color-r), var(--accent-color-g), var(--accent-color-b), 0.5);
  border-radius: 20px;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.nibTable_pagination__vi1P4 .nibTable_railWayWrap__euYKw button {
  border-right: 1px solid rgba(var(--accent-color-r), var(--accent-color-g), var(--accent-color-b), 0.5);
  margin: 0;
  height: 40px;
  border-radius: 0;
}
.nibTable_pagination__vi1P4 .nibTable_railWayWrap__euYKw button:last-of-type {
  border-right: none;
}
.nibTable_pagination__vi1P4 .nibTable_railWayWrap__euYKw button:disabled svg {
  color: #757575;
}
.nibTable_pagination__vi1P4 .nibTable_railWayWrap__euYKw > button:nth-of-type(2), .nibTable_pagination__vi1P4 .nibTable_railWayWrap__euYKw > button:nth-of-type(3) {
  width: 45px;
  min-width: unset;
}
.nibTable_pagination__vi1P4 .nibTable_railWayWrap__euYKw .nibTable_railWay__eFxci {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 40px;
  padding: 0;
  margin: 0;
}
.nibTable_pagination__vi1P4 .nibTable_railWayWrap__euYKw .nibTable_railWay__eFxci > div {
  margin: 0;
  padding-top: 0;
  padding-bottom: 0;
  height: 100%;
  border-right: 1px solid rgba(var(--accent-color-r), var(--accent-color-g), var(--accent-color-b), 0.5);
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.nibTable_pagination__vi1P4 .nibTable_railWayWrap__euYKw .nibTable_railWay__eFxci > div.nibTable_active__dSbSv {
  background-color: rgba(var(--accent-color-r), var(--accent-color-g), var(--accent-color-b), 0.5);
}

.nibTable_thumbnailCell__ofmab {
  padding-right: 5px !important;
  justify-content: center !important;
  cursor: pointer;
}

.nibTable_tableWrap__NUPqa {
  border-radius: 14px;
}`, "",{"version":3,"sources":["webpack://./src/sass/_settings.sass","webpack://./src/components/common/NibTable/nibTable.module.sass"],"names":[],"mappings":"AAAA,aAAA;AAeA,oBAAA;AAgBA,iBAAA;AA0BA,sBAAA;AAGA,mBAAA;AACA;EA3DE,aAAA;EACA,mBA4DM;EA3DN,8BA2DW;EA1DX,uBA0D0B;EAC1B,kBAAA;EACA,WAAA;ACrDF;ADsDE;EACE,eAAA;ACpDJ;ADsDI;EAnEF,aAAA;EACA,sBAmEU;EAlEV,2BAkEkB;EAjElB,uBAiE8B;EAC1B,eAAA;ACjDN;ADkDM;EACE,WAAA;AChDR;ADiDI;EAxEF,aAAA;EACA,mBAwEU;EAvEV,2BAuEe;EAtEf,uBAsE2B;EACvB,WAAA;AC5CN;AD6CE;EACE,aAjDK;EA3BP,aAAA;EACA,mBA4EQ;EA3ER,2BA2Ea;EA1Eb,uBA0EyB;EACvB,kBAAA;EACA,eAAA;EACA,WAAA;ACxCJ;ADyCI;EACE,kBAAA;ACvCN;ADwCM;EAFF;IAGI,cAAA;IACA,iBAAA;ECrCN;AACF;;ADsCA;EAEE;IACE,YAFO;EClCT;AACF;ADoCA;EAEE;IACE,YAFO;ECjCT;AACF;ADoCA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AClCF;;ADoCA;EACE,0BAtFO;ACqDT;;ADqCI;EACE,4BAAA;AClCN;;AAvEA;EACI,WAAA;EDHF,aAAA;EACA,sBCGQ;EDFR,uBCEgB;EDDhB,uBCCwB;AA6E1B;AA5EI;EDLF,aAAA;EACA,mBCKY;EDJZ,8BCIiB;EDHjB,qBCGgC;AAiFlC;AAhFQ;EACI,aAAA;EACA,eAAA;AAkFZ;AAjFY;EACI,iBAAA;AAmFhB;AAlFQ;EACI,mBAAA;EACA,kBAAA;AAoFZ;AAnFY;EACI,eAAA;AAqFhB;AApFI;EACI,WAAA;AAsFR;AArFI;EACI,aAAA;EACA,kBAAA;EACA,WAAA;EACA,oBDIC;ECHD,eAAA;EACA,cAAA;AAuFR;AAtFI;EACI,WAAA;EACA,aDDC;EA3BP,aAAA;EACA,mBC4BY;ED3BZ,uBC2BiB;ED1BjB,mBC0ByB;AA2F3B;;AAzFA;EACI,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,yBAAA;EACA,eAAA;AA4FJ;AA3FI;EACI,2BAAA;EACA,4BAAA;AA6FR;AA5FI;EACI,sBAAA;AA8FR;AA7FI;EACI,qBAAA;AA+FR;AA5FQ;EDtCN,gBA4CiB;EA3CjB,gBA2CiB;EA1CjB,YA0CiB;ECJP,yBAAA;EACA,iBAAA;EACA,mBAAA;EACA,2BAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,MAAA;EACA,WAAA;AAgGZ;AA/FY;ED1DV,aAAA;EACA,mBC0DoB;EDzDpB,uBCyDyB;EDxDzB,mBCwDiC;AAoGnC;AAnGY;EACI,aAAA;AAqGhB;AApGgB;EACI,WAAA;AAsGpB;AArGoB;EACI,WAAA;AAuGxB;AArGI;EACI,mBAAA;AAuGR;AAtGQ;ED5DN,gBA4CiB;EA3CjB,gBA2CiB;EA1CjB,YA0CiB;AC2HnB;AAxGgB;EACI,yBAAA;AA0GpB;AAzGY;EACI,yBD7DT;EC+DS,iBAAA;EACA,UAAA;EACA,WAAA;AA0GhB;AAzGgB;EDvEd,gBA4CiB;EA3CjB,gBA2CiB;EA1CjB,YA0CiB;EArDjB,aAAA;EACA,mBCiFwB;EDhFxB,yBCgF6B;ED/E7B,mBC+EuC;EACrB,WAAA;EACA,YAAA;EAEI,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;AA+GxB;AA9GoB;EACI,WAAA;AAgHxB;AA/GgB;EACI,sCAAA;AAiHpB;AAhHoB;EACI,yBDxEhB;AC0LR;;AAjHA;EACI,WD5Ce;EC6Cf,UAAA;AAoHJ;AAnHI;EACI,WAAA;EACA,qBAAA;AAqHR;AApHQ;EACI,WAAA;AAsHZ;;AAnHA;EACI,WAAA;ED3GF,aAAA;EACA,mBC2GQ;ED1GR,yBC0Ga;EDzGb,mBCyGuB;AAyHzB;;AAvHA;EACI,kBAAA;AA0HJ;;AAxHA;EACI,kBAAA;AA2HJ;;AAxHA;EACI,0BAAA;AA2HJ;AAzHQ;EACI,qCAAA;EACA,qBAAA;EACA,cAAA;AA2HZ;;AAzHA;EACI,UAAA;AA4HJ;;AAzHI;EACI,0BDlHC;AC8OT;AA1HQ;EACI,YAAA;AA4HZ;;AAxHQ;EACI,mDAAA;AA2HZ;AA1HI;EACI,WAAA;AA4HR;AA3HI;EACI,4CAAA;AA6HR;AA3HQ;EACI,oCAAA;AA6HZ;;AAxHA;EACI,eAAA;EACA,uBAAA;EACA,YALK;EAML,gBANK;EAOL,kBAAA;ED3JF,aAAA;EACA,mBC2JQ;ED1JR,uBC0Ja;EDzJb,mBCyJqB;AA8HvB;AA7HI;EACI,yBDhJD;ECiJC,gGAAA;EACA,mBAAA;EACA,gBAAA;EDjKN,aAAA;EACA,mBCiKY;EDhKZ,uBCgKiB;ED/JjB,mBC+JyB;AAkI3B;AAjIQ;EACI,sGAAA;EACA,SAAA;EACA,YAlBH;EAmBG,gBAAA;AAmIZ;AAlIY;EACI,kBAAA;AAoIhB;AAlIgB;EACI,cAAA;AAoIpB;AAlIY;EACI,WAAA;EACA,gBAAA;AAoIhB;AAlIQ;EDlLN,aAAA;EACA,mBCkLgB;EDjLhB,uBCiLqB;EDhLrB,mBCgL6B;EACnB,YAhCH;EAiCG,UAAA;EACA,SAAA;AAuIZ;AAtIY;EACI,SAAA;EACA,cAAA;EACA,iBAAA;EACA,YAAA;EACA,sGAAA;ED5Ld,aAAA;EACA,mBC4LoB;ED3LpB,uBC2LyB;ED1LzB,mBC0LiC;AA2InC;AA1IgB;EACI,gGAAA;AA4IpB;;AA1IA;EACI,6BAAA;EACA,kCAAA;EACA,eAAA;AA6IJ;;AA1IA;EACI,mBAAA;AA6IJ","sourcesContent":["/** Mixins **/\n=flex($der, $justy, $align)\n  display: flex\n  flex-direction: $der\n  justify-content: $justy\n  align-items: $align\n\n=shadow()\n  box-shadow: -5px 5px 10px 0px rgba(#000, .35)\n\n=staticHeight($height)\n  min-height: $height\n  max-height: $height\n  height: $height\n\n/** Vars (common) **/\n$main: #2F2F2F\n$main_background: #191818\n$accent: var(--accent-color)\n$accent_text: var(--accent-text-color)\n$accent_r: var(--accent-color-r)\n$accent_g: var(--accent-color-g)\n$accent_g10: var(--accent-color-g10)\n$accent_b: var(--accent-color-b)\n$text: #cecece\n$error: #f44336\n$success: rgb(102, 187, 106)\n$container_background_color: #1B1B1B\n$container_item_background_color: #212121\n$gutter: 20px\n\n/** app colors **/\n$soft_teal: #84aaaf\n$fiery_red: #ff3131\n$muted_red: #e85a4f\n$app_red: #B83336\n$soft_creamy: #f5e8dd\n$light_gray: #535353\n$golden_yellow: #ffc107\n$orange: #ffa725\n$app_orange: #DB890E\n$warm_orange: #e3a869\n$faded_pink: #d69fa2\n$purple: #8868a3\n$app_purple: #7E51A3\n$light_blue: #79a8d1\n$app_green: #16962F\n$retro_green: #4a7c59\n$deep_blue: #406ca8\n\n$main_block_top_padding: 130px\n$main_block_top_padding_s: 70px\n$header_height: 120px\n$sidebar_width: 320px\n\n$table_row_height: 55px\n\n/** Vars (MuiAlert) **/\n$MuiAlert_main_color: rgb(166, 213, 250)\n\n/** main classes **/\n.old-container\n  //padding: $gutter\n  +flex(row, space-between, flex-start)\n  position: relative\n  width: 100%\n  &.wrap\n    flex-wrap: wrap\n  .box\n    &.col\n      +flex(column, flex-start, flex-start)\n      padding: 0 calc($gutter/2)\n      > div\n        width: 100%\n    &.row\n      +flex(row, flex-start, flex-start)\n      width: 100%\n  form\n    padding: $gutter\n    +flex(row, flex-start, flex-start)\n    position: relative\n    flex-wrap: wrap\n    width: 100%\n    > .box.col\n      flex-basis: 33.33%\n      @media screen and ( min-width: 2560px )\n        flex-basis: 0%\n        margin-right: 2em\n\n@media screen and ( max-width: 580px )\n  $gutter: 5px\n  .old-container, .col, form\n    padding: $gutter\n@media screen and ( max-width: 450px )\n  $gutter: 0px\n  .old-container, .col, form\n    padding: $gutter\n\n.text-overflow-hidden\n  overflow: hidden\n  text-overflow: ellipsis\n  white-space: nowrap\n\n.icon\n  color: $accent\n\n.richtext-output-wrap\n  .se-video-container\n    figure\n      padding-bottom: 0 !important\n","@import '../../../sass/settings'\n\n$row_height: $table_row_height\n\n.wrap\n    width: 100%\n    +flex(column, center, flex-start)\n    .toolbar\n        +flex(row, space-between, flex-end)\n        .filtersWrapper\n            display: flex\n            flex-wrap: wrap\n            & + *\n                margin-left: 20px\n        .field\n            margin-bottom: 10px\n            margin-right: 10px\n            &:last-child\n                margin-right: 0\n    > div\n        width: 100%\n    .end\n        padding: calc($gutter/2)\n        text-align: center\n        width: 100%\n        padding-bottom: $gutter\n        font-size: 120%\n        color: #cecece\n    .loader\n        width: 100%\n        padding: $gutter\n        +flex(row, center, center)\n\n.table\n    width: 100%\n    border-radius: 15px\n    overflow: hidden\n    background-color: #3D3D3D\n    border-collapse: collapse\n    border-width: 0\n    td\n        border: 0 solid transparent\n        background-clip: padding-box\n    tr > td + td\n        border-left-width: 2px\n    tr + tr > td\n        border-top-width: 2px\n\n    thead\n        th\n            +staticHeight($row_height)\n            background-color: #3D3D3D\n            text-align: right\n            padding-right: 20px\n            /* word-break: break-word */\n            white-space: nowrap\n            color: #fff\n            position: sticky\n            top: 0\n            z-index: 99\n            span\n                +flex(row, center, center)\n            &.add\n                padding: 10px\n                > div\n                    width: 100%\n                    button\n                        width: 100%\n\n    tbody\n        border-radius: 15px\n        tr\n            +staticHeight($row_height)\n            &:nth-child(odd)\n                td\n                    background-color: #2A2A2A\n            td\n                background-color: $main\n\n                text-align: right\n                padding: 0\n                color: #fff\n                > div, > p, > span\n                    +staticHeight($row_height)\n                    +flex(row, flex-end, center)\n                    width: 100%\n                    height: 100%\n                    padding: \n                        top: 5px\n                        bottom: 5px\n                        left: 5px\n                        right: 20px\n                    > div\n                        width: 100%\n                > div, >p\n                    transition: background-color .5s ease\n                    &.error\n                        background-color: $error\n.edit\n    width: $row_height\n    padding: 0\n    > div\n        width: 100%\n        padding: 0 !important\n        button\n            width: 100%\n\n\n.inputCell, .dateCell, .selectCell, .customCell\n    width: 100%\n    +flex(row, flex-end, center)\n\n.inputCell\n    margin-right: 80px\n    \n.selectCell\n    margin-right: 80px\n\n\n.link\n    text-decoration: underline\n    .linkIcon\n        svg\n            color: $accent !important\n            vertical-align: super\n            padding: 0 2px\n\n.customCell\n    padding: 0\n\n.eyeCell\n    svg\n        color: $accent\n    &:disabled\n        svg\n            color: unset\n\n.selectCell\n    &.MuiInput-underline\n        &::after\n            border-bottom-color: $accent !important    \n    svg\n        color: #fff\n    &::before\n        border-bottom: 2px solid $accent\n    &:hover\n        &::before\n            border-bottom-color: #fff !important\n\n\n$pagi_h: 40px\n\n.pagination\n    margin-top: 5px \n    width: calc(100% - 4px)\n    height: $pagi_h\n    max-height: $pagi_h\n    margin-bottom: 5px\n    +flex(row, center, center)\n    .railWayWrap\n        background-color: $main\n        border: 1px solid rgba($accent_r, $accent_g, $accent_b, .5)\n        border-radius: 20px\n        overflow: hidden\n        +flex(row, center, center)\n        button\n            border-right: 1px solid rgba($accent_r, $accent_g, $accent_b, .5)\n            margin: 0\n            height: $pagi_h\n            border-radius: 0\n            &:last-of-type\n                border-right: none \n            &:disabled\n                svg\n                    color: #757575\n        > button\n            &:nth-of-type(2), &:nth-of-type(3)\n                width: 45px\n                min-width: unset\n                \n        .railWay\n            +flex(row, center, center)\n            height: $pagi_h\n            padding: 0\n            margin: 0\n            > div\n                margin: 0\n                padding-top: 0\n                padding-bottom: 0\n                height: 100%\n                border-right: 1px solid rgba($accent_r, $accent_g, $accent_b, .5)\n                +flex(row, center, center)\n                &.active\n                    background-color: rgba($accent_r, $accent_g, $accent_b, .5)\n\n.thumbnailCell\n    padding-right: 5px !important\n    justify-content: center !important\n    cursor: pointer\n\n\n.tableWrap\n    border-radius: 14px"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"old-container": `nibTable_old-container__RV+6c`,
	"wrap": `nibTable_wrap__Ie63P`,
	"box": `nibTable_box__C9CFj`,
	"col": `nibTable_col__kjBfg`,
	"row": `nibTable_row__YkmbY`,
	"text-overflow-hidden": `nibTable_text-overflow-hidden__jsD6Y`,
	"icon": `nibTable_icon__U4zja`,
	"richtext-output-wrap": `nibTable_richtext-output-wrap__hlze6`,
	"se-video-container": `nibTable_se-video-container__3p-Tp`,
	"toolbar": `nibTable_toolbar__hMvPx`,
	"filtersWrapper": `nibTable_filtersWrapper__gVo3C`,
	"field": `nibTable_field__NrESo`,
	"end": `nibTable_end__bTSEK`,
	"loader": `nibTable_loader__gBstn`,
	"table": `nibTable_table__isvFK`,
	"add": `nibTable_add__NtkP9`,
	"error": `nibTable_error__2WTkJ`,
	"edit": `nibTable_edit__c2n8X`,
	"inputCell": `nibTable_inputCell__-BQyu`,
	"dateCell": `nibTable_dateCell__V-zEZ`,
	"selectCell": `nibTable_selectCell__Lu-Gd`,
	"customCell": `nibTable_customCell__h+AXC`,
	"link": `nibTable_link__in50l`,
	"linkIcon": `nibTable_linkIcon__UAJkd`,
	"eyeCell": `nibTable_eyeCell__T-8aN`,
	"MuiInput-underline": `nibTable_MuiInput-underline__7xoQ9`,
	"pagination": `nibTable_pagination__vi1P4`,
	"railWayWrap": `nibTable_railWayWrap__euYKw`,
	"railWay": `nibTable_railWay__eFxci`,
	"active": `nibTable_active__dSbSv`,
	"thumbnailCell": `nibTable_thumbnailCell__ofmab`,
	"tableWrap": `nibTable_tableWrap__NUPqa`
};
export default ___CSS_LOADER_EXPORT___;
